import { z } from 'zod';

/**
 * Universal tags — a free-form string-array attachable to any document.
 *
 * Lets product / analytics / admin pin lightweight discriminators on
 * docs without growing a new enum every time. Picked-up by listing
 * queries, dashboards, ad-hoc cohort selection, etc.
 *
 * ```ts
 * uTags: ['promo:black_friday_2026', 'audit:disputed', 'pilot:carrier_v2']
 * ```
 *
 * **Convention** — use `namespace:value` so queries stay sane. Not
 * enforced by the schema; promotes to a stricter shape later if abuse
 * starts showing up.
 *
 * Replaces ad-hoc per-collection `tags` enums (Billing used to have one
 * with `'platform_subscription' | 'platform_addon' | …`; that role
 * moved to `Billing.source`, while uncategorised discriminators move
 * here).
 */
export const uTagsSchema = z.array(z.string().trim().min(1)).default([]);
export type UTags = z.infer<typeof uTagsSchema>;
